import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import classNames from 'classnames';
import posed, { PoseGroup } from 'react-pose';
import MetricCardsEmptyStateInner from './metricCardsEmptyStateInner';
import css from './metricCard.css';

const AnimatedMetricCard = posed.div({
    enter: {
        y: 0,
        transition: {
            y: {
                opacity: { ease: 'easeInOut', duration: 500 },
            },
        },
    },
    exit: {
        y: 20,
    },
});

function MetricCard({
    displayName,
    metricValue = '',
    changePercentage = '',
    changePercentageLabel = '',
    compareFactorName = '',
    period2MetricData = '',
    noData = false,
    isLoading = false,
    isAdminMode = false,
    className,
    metricValueClassName = '',
}) {
    return (
        <div className={classNames(css.metricCard, className)}>
            <div className={css.metricName}>{displayName}</div>
            {isLoading && <img className={css.dotsLoader} src="/static/dashboard/img/icons/dots.gif" />}
            {!isLoading && (
                <PoseGroup animateOnMount>
                    <AnimatedMetricCard key={displayName} className={css.animatedMetricCard}>
                        {noData || !metricValue ? (
                            <MetricCardsEmptyStateInner />
                        ) : (
                            <>
                                <div className={classNames(css.metricValue, metricValueClassName)}>{metricValue}</div>
                                {isAdminMode && <span>Last Period Data: {period2MetricData}</span>}
                                <div className={classNames(css.changeValue, css[compareFactorName])}>
                                    {changePercentage} <Translate id={changePercentageLabel} />
                                </div>
                            </>
                        )}
                    </AnimatedMetricCard>
                </PoseGroup>
            )}
        </div>
    );
}

MetricCard.propTypes = {
    displayName: PropTypes.string.isRequired,
    metricValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    changePercentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    changePercentageLabel: PropTypes.string,
    compareFactorName: PropTypes.string,
    period2MetricData: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    noData: PropTypes.bool,
    isLoading: PropTypes.bool,
    isAdminMode: PropTypes.bool,
    metricValueClassName: PropTypes.string,
    className: PropTypes.string,
};

export default MetricCard;
